module.exports = __webpack_public_path__ + "static/media/3.ccd1762d.svg";